import { gql } from 'apollo-boost'

export const GET_COMPONENT_TYPES = gql`
  query getComponentTypes {
    componentTypes {
      id
      name
      active
    }
  }
`

export const ADD_COMPONENT_TYPE = gql`
  mutation addComponentType($input: ComponentTypeAddInput!) {
    addComponentType(input: $input) {
      id
      name
      active
    }
  }
`

export const UPDATE_COMPONENT_TYPE = gql`
  mutation updateComponentType($input: ComponentTypeUpdateInput) {
    updateComponentType(input: $input) {
      id
      name
      active
    }
  }
`

export const DELETE_COMPONENT_TYPE = gql`
  mutation deleteComponentType($id: ID) {
    deleteComponentType(id: $id)
  }
`

export const GET_QUANTITY_TYPES = gql`
  query getQuantityTypes {
    quantityTypes
  }
`

export const GET_COMPONENT_GROUPS = gql`
  query getComponentGroups {
    componentGroups {
      id
      name
      active
      quantityType
    }
  }
`

export const ADD_COMPONENT_GROUP = gql`
  mutation addComponentGroup($input: ComponentGroupAddInput!) {
    addComponentGroup(input: $input) {
      id
      name
      active
      quantityType
    }
  }
`

export const UPDATE_COMPONENT_GROUP = gql`
  mutation updateComponentGroup($input: ComponentGroupUpdateInput) {
    updateComponentGroup(input: $input) {
      id
      name
      active
      quantityType
    }
  }
`

export const DELETE_COMPONENT_GROUP = gql`
  mutation deleteComponentGroup($id: ID) {
    deleteComponentGroup(id: $id)
  }
`

//Activity Types

export const GET_CATEGORIES = gql`
  query getCategories($shopId: String) {
    categories(shopId: $shopId) {
      id
      name
      unitType
    }
  }
`

export const GET_ACTIVITY_TYPES = gql`
  query getActivityTypes {
    activityTypes {
      id
      name
      description
      active
      categories
    }
  }
`

export const ADD_ACTIVITY_TYPE = gql`
  mutation addActivityType($input: ActivityTypeAddInput!) {
    addActivityType(input: $input) {
      id
      name
      description
      active
      categories
    }
  }
`

export const UPDATE_ACTIVITY_TYPE = gql`
  mutation updateActivityType($input: ActivityTypeUpdateInput) {
    updateActivityType(input: $input) {
      id
      name
      description
      active
      categories
    }
  }
`

export const DELETE_ACTIVITY_TYPE = gql`
  mutation deleteActivityType($id: ID) {
    deleteActivityType(id: $id)
  }
`

// Loss Reasons
export const GET_LOSS_REASONS = gql`
  query getLossReasons {
    lossReasons {
      total
      values {
        ... on LossReasons {
          id
          description
          active
        }
      }
    }
  }
`

//Checklist

export const GET_CHECKLISTS = gql`
  query checkLists($start: Int, $limit: Int, $searchTerm: String) {
    checkLists(start: $start, limit: $limit, searchTerm: $searchTerm) {
      total
      values {
        ... on CheckList {
          id
          name
          categoryId
          taskDetails {
            name
            position
          }
        }
      }
      skip
      limit
    }
  }
`

export const GET_CHECKLIST_BYID = gql`
  query checkListById($id: ID) {
    checkListById(id: $id) {
      id
      name
      categoryId
      taskDetails {
        name
        position
      }
    }
  }
`

export const ADD_LOSS_REASON = gql`
  mutation addLossReasons($input: LossReasonsAddInput!) {
    addLossReasons(input: $input) {
      id
      description
      active
    }
  }
`

export const ADD_CHECKLIST = gql`
  mutation addCheckList($input: CheckListAddInput!) {
    addCheckList(input: $input) {
      id
      name
      categoryId
      taskDetails {
        name
        position
      }
    }
  }
`

export const UPDATE_LOSS_REASON = gql`
  mutation updateLossReasons($input: LossReasonsUpdateInput) {
    updateLossReasons(input: $input) {
      id
      description
      active
    }
  }
`

export const UPDATE_CHECKLIST = gql`
  mutation updateCheckList($input: CheckListUpdateInput!) {
    updateCheckList(input: $input) {
      id
      name
      categoryId
      taskDetails {
        name
        position
      }
    }
  }
`

export const DELETE_LOSS_REASON = gql`
  mutation deleteLossReasons($id: ID) {
    deleteLossReasons(id: $id)
  }
`
export const DELETE_CHECKLIST = gql`
  mutation deleteCheckList($id: ID) {
    deleteCheckList(id: $id)
  }
`



// WEBPACK FOOTER //
// ./src/containers/Settings/Manufacturing/GraphQL.js